import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Custom hook to manage browser theme color based on current route
 * Sets black theme color for home page and error pages, white for all others
 */
export const useThemeColor = () => {
  const location = useLocation();

  useEffect(() => {
    const updateThemeColor = () => {
      const pathname = location.pathname;
      
      // Define pages that should have black theme color
      const blackThemePages = [
        '/',  // Home page
        '/error/401',
        '/error/403', 
        '/error/404',
        '/error/500',
        '/error/503'
      ];
      
      // Check if current path matches any black theme pages
      // Also check for 404 fallback (any unmatched route)
      const isBlackThemePage = blackThemePages.includes(pathname) || 
                              (pathname !== '/' && 
                               !pathname.startsWith('/studio/') &&
                               !pathname.startsWith('/search') &&
                               !pathname.startsWith('/users/') &&
                               !pathname.startsWith('/profile') &&
                               !pathname.startsWith('/bookings') &&
                               !pathname.startsWith('/creator') &&
                               !pathname.startsWith('/wishlists') &&
                               !pathname.startsWith('/messages') &&
                               !pathname.startsWith('/calendar') &&
                               !pathname.startsWith('/services-studios') &&
                               !pathname.startsWith('/studio-erstellen') &&
                               !pathname.startsWith('/anmelden') &&
                               !pathname.startsWith('/registrieren') &&
                               !['/datenschutz', '/impressum', '/kontakt'].includes(pathname));

      const themeColor = isBlackThemePage ? '#000000' : '#ffffff';
      
      // Update meta theme-color tag
      let metaThemeColor = document.querySelector('meta[name="theme-color"]');
      if (!metaThemeColor) {
        metaThemeColor = document.createElement('meta');
        metaThemeColor.name = 'theme-color';
        document.head.appendChild(metaThemeColor);
      }
      metaThemeColor.content = themeColor;

      // Also update apple-mobile-web-app-status-bar-style for iOS
      let metaStatusBar = document.querySelector('meta[name="apple-mobile-web-app-status-bar-style"]');
      if (!metaStatusBar) {
        metaStatusBar = document.createElement('meta');
        metaStatusBar.name = 'apple-mobile-web-app-status-bar-style';
        document.head.appendChild(metaStatusBar);
      }
      // Use 'black-translucent' for black theme, 'default' for white theme
      metaStatusBar.content = isBlackThemePage ? 'black-translucent' : 'default';
    };

    updateThemeColor();
  }, [location.pathname]);
};
